import { createRoot } from 'react-dom/client';
import './index.css';
import { PersistGate } from 'redux-persist/integration/react';
import { Provider } from 'react-redux';
import { persistor, store } from 'redux/store';
import { ToastContainer } from 'react-toastify';
import { ThemeProvider } from '@emotion/react';
import { createTheme } from '@mui/material/styles';
import { HelmetProvider } from 'react-helmet-async';
import { App } from './App';
import 'react-toastify/dist/ReactToastify.css';
import 'flag-icons/css/flag-icons.min.css';

const rootElement = document.getElementById('root') as HTMLElement;

const root = createRoot(rootElement);

const theme = createTheme({
	palette: {
		primary: {
			main: '#016193',
			contrastText: '#fff',
			light: '#bdd2df',
		},
		secondary: {
			main: '#7ea13a',
			contrastText: '#fff',
		},
		success: {
			main: '#7ea13a',
			contrastText: '#fff',
			light: '#7ea13a80',
		},
		error: {
			main: '#d32f2f',
			contrastText: '#fff',
			light: '#d32f2f7d',
		},
		info: {
			main: '#6ec1e4',
		},
		warning: {
			main: '#e7af00',
			light: '#e7af0080',
		},
		grey: {
			100: '#f5f5f5',
			200: '#eeeeee',
			300: '#e0e0e0',
			400: '#bdbdbd',
			500: '#9e9e9e',
			600: '#757575',
			700: '#616161',
			800: '#424242',
			900: '#212121',
		},
	},
});

root.render(
	<Provider store={store}>
		<PersistGate loading={null} persistor={persistor}>
			<ThemeProvider theme={theme}>
				<HelmetProvider>
					<App />
				</HelmetProvider>
				<ToastContainer />
			</ThemeProvider>
		</PersistGate>
	</Provider>,
);
